import * as fetch from '../../../utils/action'
// import { getTotalNumber, downloadFilename } from '../totalMethod'
import { getTotalNumber } from '../totalMethod'
import { formatDate, getReportSignature } from '@/utils/formUtils.js'
// import detetionDatas from '../datas/detetion'

// import timeutils from 'utils/wt-time-utils'
// import mallDatas from '../datas/mall'
// import { workOrderType } from 'json/mall-options'
import { getDeliveryType, getcontractStatus, getdayType, cycleChange } from 'enumeration/lab-order.js'
export default {
  // 创建代理商合同
  getAgentcontractsCreate(ctx, data) {
    return fetch.getAgentcontractsCreate(data).then(res => {
      return res.data
    })
  },
  // 编辑代理商合同
  getAgentcontractsEdit(ctx, data) {
    return fetch.getAgentcontractsEdit(data).then(res => {
      return res.data
    })
  },
  // 创建代理商产品
  getAgentproductCreate(ctx, data) {
    return fetch.getAgentproductCreate(data).then(res => {
      return res.data
    })
  },
  // 编辑代理商产品（国科大专用）
  agentProductEdit(ctx, data) {
    return fetch.agentProductEdit(data).then(res => {
      return res.data
    })
  },
  // 编辑代理商产品
  getAgentproductEdit(ctx, data) {
    return fetch.getAgentproductEdit(data).then(res => {
      return res.data
    })
  },
  // 代理商商品查询
  getAgentproductQuery(ctx, data) {
    return fetch.getAgentproductQuery(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  // 获取客户列表
  getRoleList(ctx, data) {
    return fetch.getRoleList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(ele => {
        ele.createdDate = formatDate(ele.createdDate)
      })
      return result
    })
  },
  // 获取合同产品详情
  getProductDetail(ctx, data) {
    return fetch.getProductDetail(data).then(res => {
      let result = res.data.agentProduct
      result.directSendSampleCopy = result.directSendSample ? '实验室' : 'HG'
      result.packages.packageProductionTypeCopy = result.packages && result.packages.packageProductionType === 'PROPRIETARY' ? '系统自动分析报告' : '第三方出具报告'
      result.packages.labProcessCopy = result.packages && result.packages.labProcess ? '是（包含检测及报告）' : '否（仅提供报告）'
        // result.contractStartTime = formatDate(result.contractStartTime)
        // result.contractEndTime = formatDate(result.contractEndTime)
        // result.signedDate = formatDate(result.signedDate)
        // result.createdDate = formatDate(result.createdDate)
        // result.deliveryType = result.agentContractData ? getDeliveryType(result.agentContractData.deliveryType) : ''
        // result.dayType = result.agentContractData ? getdayType(result.agentContractData.dayType) : ''
      return res.data
    })
  },
  // 获取合同详情
  getContractDetail(ctx, data) {
    return fetch.getContractDetail(data).then(res => {
      let result = res.data
      result.contractStartTime = formatDate(result.contractStartTime)
      result.contractEndTime = formatDate(result.contractEndTime)
      result.signedDate = formatDate(result.signedDate)
      result.createdDate = formatDate(result.createdDate)
      return result
    })
  },
  // 获取合同列表
  getContractList(ctx, data) {
    return fetch.getContractList(data).then(res => {
      res.data.forEach(ele => {
        ele.signedDate = ele.signedDate ? formatDate(ele.signedDate) : ele.signedDate
        ele.contractStartTime = ele.contractStartTime ? formatDate(ele.contractStartTime) : ''
        ele.contractEndTime = ele.contractEndTime ? formatDate(ele.contractEndTime) : ''
        ele.clientOrganization = ele.clientOrganization && ele.clientOrganization.name ? ele.clientOrganization.name : ''
        ele.status = ele.status ? getcontractStatus(ele.status) : ''
        ele.isLimit = ele.isLimit ? '是' : '否'
        ele.contractNumber = ele.contractNumber ? ele.contractNumber : '--'
        ele.remainingAmountChange = ele.contractAmount && ele.contractAmount !== 0 ? ele.remainingAmount : '--'
        ele.contractAmountChange = ele.contractAmount && ele.contractAmount !== 0 ? ele.contractAmount : '--'
        ele.usedAmountChange = ele.usedAmount ? ele.usedAmount : '--'
        ele.productContractAmountChange = ele.productContractAmount ? ele.productContractAmount : '--'
      })
      let result = getTotalNumber(res)
      return result
    })
  },
  // 获取合同商品列表
  getProductList(ctx, data) {
    return fetch.getProductList(data).then(res => {
      res.data.forEach(ele => {
        if (ele.deliveryType) {
          ele.deliveryType = ele.deliveryType ? ele.deliveryType.map(e => getDeliveryType(e)).toString() : ''
        }
        ele.productPeriod = ele.period ? cycleChange(ele.period) + getdayType(ele.dayType) : '--'
        if (ele.agentProduct.labProduct) {
          ele.agentProduct.labProduct.detectionPeriod = cycleChange(ele.agentProduct.labProduct.testCycle) + getdayType(ele.agentProduct.labProduct.dayType)
        }
        ele.status = ele.status ? getcontractStatus(ele.status) : '--'
        ele.contractName = ele.contractName ? ele.contractName : '--'
        ele.contractPriceChange = ele.contractPrice ? ele.contractPrice : '--'
        if (ele.agentContractData) {
          ele.agentContractData.remainingAmountChange = ele.agentContractData.contractAmount === 0 ? '--' : ele.agentContractData.remainingAmount
          ele.agentContractData.contractAmountChange = ele.agentContractData.contractAmount === 0 ? '--' : ele.agentContractData.contractAmount
        }
      })
      let result = getTotalNumber(res)
      return result
    })
  },
  // 删除客户合同
  deleteContract(ctx, data) {
    return fetch.deleteContract(data).then(res => {
      return res.data
    })
  },
  // 删除合同商品
  deleteProduct(ctx, data) {
    return fetch.deleteProduct(data).then(res => {
      return res.data
    })
  },
  deleteAgentProduct(ctx, data) {
    return fetch.deleteAgentProduct(data).then(res => {
      return res.data
    })
  },
  getAgentProduct(ctx, id) {
    return fetch.getAgentProduct(id).then(res => {
      res.data.deliveryTypeCopy = res.data.deliveryType ? res.data.deliveryType.map(e => getDeliveryType(e)).toString() : '--'
        // if (res.data.directSendSample) {
      res.data.directSendSampleCopy = res.data.directSendSample ? '实验室' : 'HG'
      res.data.packages.packageProductionTypeCopy = res.data.packages && res.data.packages.packageProductionType === 'PROPRIETARY' ? '系统自动分析报告' : '第三方出具报告'
      res.data.packages.labProcessCopy = res.data.packages && res.data.packages.labProcess ? '是（包含检测及报告）' : '否（仅提供报告）'
        // }
      res.data.productPeriod = res.data.testCycle ? cycleChange(res.data.testCycle) + getdayType(res.data.dayType) : '--'
      return res.data
    })
  },
  // 选择已有商品
  getUserProduct(ctx, data) {
    return fetch.getUserProduct(data).then(res => {
      res.data.forEach(ele => {
        if (ele.deliveryType) {
          ele.changeDeliveryType = ele.deliveryType ? ele.deliveryType.map(e => getDeliveryType(e)).toString() : '--'
        }
        ele.productPeriod = ele.testCycle ? cycleChange(ele.testCycle) + getdayType(ele.dayType) : '--'
        if (ele.labProduct) {
          ele.labProduct.changeCycle = cycleChange(ele.labProduct.testCycle) + getdayType(ele.labProduct.dayType)
        }
        if (ele.mappingUpStreamProduct === null) {
          ele.mappingUpStreamProduct = {}
          ele.mappingUpStreamProduct.name = '--'
        }
      })
      let result = getTotalNumber(res)
      return result
    })
  },
  getCount(ctx, data) {
    return fetch.getCount(data).then(res => {
      return res
    })
  },
  // 获取签章列表
  getSignatureList(ctx, data) {
    return fetch.getSignatureList(data).then(res => {
      res.data.forEach(ele => {
        ele.reportSignature = ele.reportSignature ? '有' : '无'
        if (ele.signatures) {
          if (ele.signatures[0]) {
            ele.reportSignatureOne = getReportSignature(ele.signatures[0].signature, ele.signatures[0].name)
          }
          if (ele.signatures[1]) {
            ele.reportSignatureTwo = getReportSignature(ele.signatures[1].signature, ele.signatures[1].name)
          }
          if (ele.signatures[2]) {
            ele.reportSignatureThree = getReportSignature(ele.signatures[2].signature, ele.signatures[2].name)
          }
        }
      })
      let result = getTotalNumber(res)
      return result
    })
  },
  // 创建客户签章
  createSignatureList(ctx, data) {
    return fetch.createSignatureList(data).then(res => {
      return res
    })
  },
  // 创建客户签章
  deleteSignature(ctx, data) {
    return fetch.deleteSignature(data).then(res => {
      return res
    })
  },
  // 获取客户签章详情
  getSignatureDetail(ctx, data) {
    return fetch.getSignatureDetail(data).then(res => {
      return res
    })
  },
  // 编辑客户签章详情
  updateSignatureDetail(ctx, data) {
    return fetch.updateSignatureDetail(data).then(res => {
      return res
    })
  },
  // 实验室订单导出记录删除
  DeleteLabOrderHistory(ctx, data) {
    return fetch.DeleteLabOrderHistory(data).then(res => {
      return res
    })
  },
  // 实验室订单导出记录删除
  getTenantInfo(ctx, data) {
    return fetch.getTenantInfo(data).then(res => {
      ctx.commit('updateTenantInfo', res.data)
      return res.data
    })
  },
  deleteDownloadHistory(ctx, id) {
    return fetch.deleteDownloadHistory(id).then(res => {
      return res.data
    })
  },
  // 本地环境 不选择组织 指定创建用户
  createOrganizationLocal(ctx, data) {
    return fetch.createOrganizationLocal(data).then(res => {
      return res.data
    })
  },
  // 终止合同
  terminateContracts(ctx, data) {
    return fetch.terminateContracts(data).then(res => {
      return res.data
    })
  },
  // 终止合同商品
  terminateProduct(ctx, data) {
    return fetch.terminateProduct(data).then(res => {
      return res.data
    })
  }
}